'use strict'

import React from 'react';

import Layout from './Layout.jsx';
import DragAndDropContent from './components/DragAndDropContent.jsx';
import DragAndDropTarget from './components/DragAndDropTarget.jsx';
import DragAndDropSource from './components/DragAndDropSource.jsx';
import Portfolio from './Portfolio.jsx';
import Flag from './components/Flag.jsx';
import PopupDescription from './components/PopupDescription.jsx';
import StatusIndicator from './components/StatusIndicator.jsx';
import FilterStatus from './components/FilterStatus.jsx';

import Translations from '../app/utils/translations.js';
let translations=new Translations([
    require('./portfolio/labels/english.js'),
    require('./portfolio/labels/norwegian.js')
]);

class StatusDescription extends React.Component {
  render() {
    var message={date:this.props.date, content:this.props.content};
    return (
      <PopupDescription {...this.props} {...message}>
        <StatusIndicator status={this.props.status}/>
      </PopupDescription>
    );
  }
}

class FlagDescription extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    var title="";
    if (this.props.requestedPhase!==undefined) {
      let projectType=this.props.tenant!==undefined && this.props.tenant.projectTypes!==undefined
        ? this.props.tenant.projectTypes.find(type=>type.id===this.props.requestedPhase.projectType.id)
        : this.props.projectTypes!==undefined
          ? this.props.projectTypes.find(type=>type.id===this.props.requestedPhase.projectType.id)
          : undefined;
      title=labels.requestedPhase+(projectType!==undefined ? " "+projectType.phases.find(phase=>phase.id===this.props.requestedPhase.id).text : "");
    } else if (this.props.recommendedProjectClosure!==undefined) {
      title=this.props.recommendedProjectClosure.description;
    } else if (this.props.requestedStageTransition!==undefined) {
      if (this.props.requestedStageTransition.stage!==undefined) {
        title=labels.requestedStageTransition+" "+this.props.requestedStageTransition.stage.name;
      } else if (this.props.requestedStageTransition.description!==undefined) {
        title=this.props.requestedStageTransition.description;
      }
    }
    var message=this.props.recommendedProjectClosure!==undefined ? {
      date:this.props.recommendedProjectClosure.date,
      content: this.props.recommendedProjectClosure.comments!==undefined
            ? this.props.recommendedProjectClosure.comments
            : <i>No description available</i>,
      title: title
    }  : this.props.requestedPhase!==undefined ? {
      date: this.props.requestedPhase.date,
      content: this.props.requestedPhase.comments!==undefined ? this.props.requestedPhase.comments : <i>No description available</i>,
      title: title
    } : this.props.requestedStageTransition!==undefined ? {
      date:this.props.requestedStageTransition.date,
      content: this.props.requestedStageTransition.stage!==undefined
          ? this.props.requestedStageTransition.stage.comments
          : this.props.requestedStageTransition.comments!==undefined
            ? this.props.requestedStageTransition.comments
            : <i>No description available</i>,
      title: title
    } : this.props.requestedStageException!==undefined ? {
      date:this.props.requestedStageException.date,
      content: this.props.requestedStageException.summary!==undefined ? this.props.requestedStageException.summary : <i>No description available</i>
    } : undefined;
    return (
      <PopupDescription {...this.props} {...message}>
        <Flag {...this.props}/>
      </PopupDescription>
    );
  }
}


class ProjectSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hover: false};
  }

  toggleHover(event) {
    event.preventDefault();
     this.setState({hover: !this.state.hover});
   }

  prioritize(item,target) {
    this.props.prioritize({id:item.id, position:target.position, portfolio:this.props.portfolio});
  }

  render() {
    let labels=translations.getTranslation(this.props);
    var bgColor=this.state.hover ? "#f1fbfe" : "#ffffff";
    var project=this.props.project;
    var rowStyle=this.props.rowStyle;
    var name=project.name!==undefined && project.name!==null && project.name.trim().length>0 ? project.name : <i>(no name)</i>;
    let link=(<a href={(project.isProgramme ? "/programmes/" : project.isProduct ? "/products/" : project.isRelease ? "/releases/" : "/projects/")+project.id}>{name}</a>);
    var title=this.props.disablePriority!==true && project.isStarted ? (
      <DragAndDropSource prioritize={this.prioritize.bind(this)} id={project.id}>
        {link}
      </DragAndDropSource>
    ) : link;
    let projectType=this.props.tenant!==undefined && this.props.tenant.projectTypes!==undefined
      ? this.props.tenant.projectTypes.find(projectType=>projectType.id===project.projectType)
      : this.props.projectTypes!==undefined
        ? this.props.projectTypes.find(projectType=>projectType.id===project.projectType)
        : undefined;
    let currentPhase=project.currentPhase!==undefined && projectType!==undefined && projectType.phases!==undefined ? projectType.phases.find(phase=>phase.id===project.currentPhase.id) : undefined;
    let activeReleases=this.props.itemType==="product" && project.isProduct && project.releases!==undefined
      ? project.releases.filter(release=>release.active)
        .sort((a,b)=>a.activated > b.activated ? -1 : a.activated < b.activated ? 1 : 0)
      : [];
    var phase=this.props.itemType==="programme"
      ? undefined
      : this.props.itemType==="product"
        ? activeReleases.length>0
          ? activeReleases[0].name
          : labels.product.noActiveReleases
        : currentPhase!==undefined ? currentPhase.text : project.phase;
    return (
        <tr onMouseEnter={this.toggleHover.bind(this)} onMouseLeave={this.toggleHover.bind(this)} style={{backgroundColor:bgColor}}>
          {this.props.disablePriority!==true ? (
            <td style={Object.assign({},rowStyle,{color:this.props.itemType==="product" ? "white" : undefined})}>
              {this.props.position}{this.props.showPriority ? (
                <span> ({this.props.project.priority})</span>
              ) : null}
            </td>
          ) : null}
          <td style={Object.assign({},rowStyle,{paddingTop:0, paddingBottom:0, textAlign: "left"})}>
            {this.props.disablePriority!==true && project.priority!==undefined && this.props.itemType!=="product" ? (
              <DragAndDropTarget position={project.priority}>
                <div style={{paddingTop:rowStyle.padding, paddingBottom:rowStyle.padding}}>
                  {title}
                </div>
              </DragAndDropTarget>
            ) : (
              title
            )}
          </td>
          <td style={rowStyle}><StatusDescription {...this.props} selection={this.props.selection} {...project.overallStatus} date={project.statusDate}/></td>
          <td style={rowStyle}>{phase}{project.isStopped? " ("+labels.projectStatus.stopped+")" : null}{project.isPaused ? " ("+labels.projectStatus.paused+")" : null}</td>
          <td style={rowStyle}><FlagDescription {...this.props} selection={this.props.selection} requestedStageException={project.requestedStageException} requestedStageTransition={project.requestedStageTransition} requestedPhase={project.requestedPhase} recommendedProjectClosure={project.recommendedProjectClosure}/></td>
          <td style={rowStyle}><StatusDescription {...this.props} selection={this.props.selection} {...project.benefits} date={project.statusDate}/></td>
          <td style={rowStyle}><StatusDescription {...this.props} selection={this.props.selection} {...project.time} date={project.statusDate}/></td>
          <td style={rowStyle}><StatusDescription {...this.props} selection={this.props.selection} {...project.cost} date={project.statusDate}/></td>
          <td style={rowStyle}><StatusDescription {...this.props} selection={this.props.selection} {...project.quality} date={project.statusDate}/></td>
          <td style={rowStyle}><StatusDescription {...this.props} selection={this.props.selection} {...project.scope} date={project.statusDate}/></td>
          <td style={rowStyle}><StatusDescription {...this.props} selection={this.props.selection} {...project.risk} date={project.statusDate}/></td>
        </tr>
    );
  }
}

function getProgramModifiedTranslations(props) {
  var labels=translations.getTranslation(props);
  if (props.itemType==="programme") {
    let programmeLabels=translations.getTranslation(props).programme;
    labels=Object.keys(labels)
      .reduce((object,key)=>
        Object.assign({},object,{
          [key]:Object.assign({},labels[key],programmeLabels[key])
        }));
  }
  if (props.itemType==="product") {
    let productLabels=translations.getTranslation(props).product;
    labels=Object.keys(labels)
      .reduce((object,key)=>
        Object.assign({},object,{
          [key]:Object.assign({},labels[key],productLabels[key])
        }));
  }
  return labels;
}

class InactiveProjects extends React.Component {
  constructor(props) {
    super(props);
    this.state={visible:false}
  }

  toggle(event) {
    event.preventDefault();
    this.setState({visible:!this.state.visible});
  }

  render() {
    let labels=getProgramModifiedTranslations(this.props);
    return this.props.projects!==undefined && this.props.projects.length>0 ?
      this.state.visible ? (
        <tbody style={{textAlign:"center", backgroundColor:"lightgrey", borderCollapse: "separate", borderTop: "solid black 3px"}}>
          <tr>
            <td colSpan={this.props.disablePriority!==true ? "2" : "1"} style={{borderTop:"solid 2px black", padding:10}}>
              <a href="#" onClick={this.toggle.bind(this)}>{labels.inactive.hide}</a>
            </td>
            <td colSpan="9"></td>
          </tr>
          {this.props.projects.map(project=><ProjectSummary {...this.props} selection={this.props.selection}  key={project.id} project={project} rowStyle={this.props.rowStyle}/>)}
        </tbody>
      ) : (
        <tbody style={{textAlign:"center", backgroundColor:"lightgrey", borderCollapse: "separate", borderTop: "solid black 3px"}}>
          <tr>
            <td colSpan={this.props.disablePriority!==true ? "2" : "1"} style={{borderTop:"solid 2px black", padding:10}}>
              <a href="#" onClick={this.toggle.bind(this)}>{translations.formatLabel(labels.inactive.show,this.props.projects.length,this.props.projects.length>1 ? labels.inactive.projectsPlural : "")}</a>
            </td>
            <td colSpan="9"></td>
          </tr>
        </tbody>
      )
    : null;
  }
}

class ProjectTableItems extends React.Component {
  render() {
    let labels=getProgramModifiedTranslations(this.props);
    var projects=this.props.projects;
    var prioritizableProjects=(projects!==undefined) ? projects.filter(function(project) { return project.priority!==undefined && project.isStarted;}): [];
    var startingProjects=(projects!==undefined) ? projects.filter(function(project) { return project.priority===undefined && project.isStarted;}) : [];
    var rowStyle={display:"table-cell", borderBottom:"1px solid #ddd", padding: 8, textAlign:"center"};
    var startingRowStyle=Object.assign({},rowStyle,{fontStyle: "italic"});
    var inactiveRowStyle=Object.assign({},rowStyle,{color:"darkgrey"});
    var historicRowStyle=rowStyle;
    var prioritize=this.props.prioritize;
    var statusWidth=120;
    var selection={showDetails:this.props.showDetailsOf,visible:this.props.visibleDetails};
    var portfolio=this.props.portfolio;
    var inactiveProjects=(projects!==undefined) ? projects.filter(project=>!project.isStarted) : [];
    var props=this.props;
    return (
      <table style={{width: "100%", lineHeight: "20px", borderCollapse: "collapse", borderSpacing: 0, marginBottom: 20, marginTop: 0, marginRight: 0, marginLeft: 0, fontFamily: "Lato, Arial, 'Helvetica Neue', Helvetica, sans-serif", fontSize: "11px"}}>
        <thead>
          <tr>
            {this.props.disablePriority!==true ? (
              <th style={Object.assign({},rowStyle,{color:this.props.itemType==="product" ? "white" : undefined, paddingLeft:30})}>{labels.columns.priority}</th>
            ) : null}
            <th style={Object.assign({},rowStyle,{textAlign: "left", minWidth:230})}>{labels.columns.name}</th>
            <th style={Object.assign({},rowStyle,{width:statusWidth})}>{labels.columns.status}</th>
            <th style={Object.assign({},rowStyle,{minWidth:130, color: this.props.itemType==="programme" ? "white" : undefined})}>{labels.columns.stage}</th>
            <th style={Object.assign({},rowStyle,{width:statusWidth})}></th>
            <th style={Object.assign({},rowStyle,{width:statusWidth})}>{labels.columns.benefits}</th>
            <th style={Object.assign({},rowStyle,{width:statusWidth})}>{labels.columns.time}</th>
            <th style={Object.assign({},rowStyle,{width:statusWidth})}>{labels.columns.cost}</th>
            <th style={Object.assign({},rowStyle,{width:statusWidth})}>{labels.columns.quality}</th>
            <th style={Object.assign({},rowStyle,{width:statusWidth})}>{labels.columns.scope}</th>
            <th style={Object.assign({},rowStyle,{width:statusWidth})}>{labels.columns.risk}</th>
          </tr>
        </thead>
        <tbody style={{textAlign:"center"}}>
          {prioritizableProjects.slice(0).sort((a,b)=>a.priority<b.priority ? -1 : a.priority===b.priority ? 0 : 1).map(function(project,index) {
            return <ProjectSummary {...props} selection={selection} key={index} prioritize={prioritize} position={index+1} project={project} rowStyle={rowStyle} portfolio={portfolio}/>;
          })}
          {this.props.disablePriority!==true && (prioritizableProjects.length===0 || startingProjects.length>0) ? (
            <tr>
              <td colSpan="2">
                <DragAndDropTarget position={prioritizableProjects.length+1}>
                  <div style={{padding: 15}}>
                    {labels.prioritize.drop}
                  </div>
                </DragAndDropTarget>
              </td>
              <td colSpan="9"></td>
            </tr>
          ) : null}
        </tbody>
        <tbody style={{textAlign:"center",borderTop:"solid grey 3px"}}>
          {startingProjects.map(function(project) {
            return <ProjectSummary {...props} selection={selection} prioritize={prioritize} key={project.id} project={project} rowStyle={startingRowStyle}/>;
          })}
        </tbody>
        {this.props.historicProjects!==undefined ? (
          <tbody style={{textAlign:"center",borderTop:"solid grey 3px", backgroundColor: "#c8d1e8"}}>
            {this.props.historicProjects.map(function(project) {
              return <ProjectSummary {...props} selection={selection} prioritize={prioritize} key={project.id} project={project} rowStyle={historicRowStyle}/>;
            })}
          </tbody>
        ) : null}
        <InactiveProjects {...props} selection={selection} rowStyle={inactiveRowStyle} projects={inactiveProjects}/>
      </table>

    );
  }
}

class ProjectTable extends React.Component {
  render() {
    let programmes=this.props.projects.filter(project=>project.isProgramme===true);
    let products=this.props.projects.filter(project=>project.isProduct===true).map((product,index)=>Object.assign({},product,{priority: index+1}));
//    let projects=this.props.projects.filter(project=>project.isProgramme!==true && project.isProduct!==true);
    let projects=this.props.projects.filter(project=>project.isProduct!==true);
    let labels=translations.getTranslation(this.props).general.sections;
    return (
      <div>
        {false && programmes.length>0 ? (
          <div style={{paddingBottom:20}}>
            <h3 style={{backgroundColor: "white", padding: "25px 0px 0px 30px", fontFamily: "Lato, Arial, 'Helvetica Neue', Helvetica, sans-serif"}}>{labels.programmes}</h3>
            <ProjectTableItems {...this.props} projects={programmes} itemType="programme"/>
          </div>
        ) : null }
        {projects.length>0 ? (
          <div>
            <h3 style={{backgroundColor: "white", padding: "25px 0px 0px 30px", fontFamily: "Lato, Arial, 'Helvetica Neue', Helvetica, sans-serif"}}>
              {projects.filter(item=>item.isProgramme===true).length>0
                ? labels.programmes+", "
                : null }
              {projects.filter(item=>item.isRelease===undefined).length>0
                ? projects.filter(item=>item.isRelease===true).length>0
                  ? labels.projectsAndReleases
                  : labels.projects
                : labels.releases
              }
            </h3>
            <ProjectTableItems {...this.props} projects={projects}/>
          </div>
        ) : null }
        {products.length>0 ? (
          <div style={{paddingBottom:20, paddingTop:10}}>
            <h3 style={{backgroundColor: "white",  padding: "25px 0px 0px 30px", fontFamily: "Lato, Arial, 'Helvetica Neue', Helvetica, sans-serif"}}>{labels.products}</h3>
            <ProjectTableItems {...this.props} projects={products} itemType="product"/>
          </div>
        ) : null }
      </div>
    );
  }
}

export class ProjectStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state={visibleDetails:undefined};
    this.showDetailsOf=this.showDetailsOf.bind(this);
  }

  showDetailsOf(id) {

    this.setState({visibleDetails:id});
  }
  render() {
    let labels=translations.getTranslation(this.props);
    var projects=this.props.projects;
    return (
      <div>
        <FilterStatus {...this.props}/>
        {projects!==undefined && projects.length>0 ? (
          this.props.disablePriority!==true ? (
            <DragAndDropContent>
              <ProjectTable {...this.props} showDetailsOf={this.showDetailsOf} visibleDetails={this.state.visibleDetails}/>
            </DragAndDropContent>
          ) : (
            <ProjectTable {...this.props} showDetailsOf={this.showDetailsOf} visibleDetails={this.state.visibleDetails}/>
          )
        ) : (
          <div style={{marginTop:20, marginLeft: 30}}>
            <i>{labels.empty}</i>
          </div>
        )}
      </div>

    );
  }
}

export default class IndexPage extends React.Component {
  render() {
    return (
      <Layout {...this.props}>
        <Portfolio {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/Index.jsx